import { CallEntity } from "./call-entity";

export interface CallSessionControlMessage {

    id: string;

    kind: CallSessionControlKind;

    call_id: string;

    installation_id: string;

    // Bridge-specific fields
    offerer?: CallEntity;

    offerer_peer_id?: string;

    answerer?: CallEntity;

    answerer_peer_id?: string;

}

// export type CallSessionControlKind = "new" | "hold" | "resume" | "bridge" | "accept" | "answer";

export enum CallSessionControlKind {
    New = "new",
    Hold = "hold",
    Resume = "resume",
    Bridge = "bridge",
    Accept = "accept",
    Answer = "answer"
}
